// components/CustomBox.tsx
import { Box as MuiBox, BoxProps } from "@mui/material";

type Props = Omit<BoxProps, "component">;

const CustomBox = (props: Props) => <MuiBox component="div" {...props} />;

export { CustomBox as Box };
export default CustomBox;
